import React, { forwardRef, useContext, useState } from "react";
import PropTypes from "prop-types";

import { LinkListContext } from "./LinkListContext";

import styles from "./LinkList.scss";

export const LinkListColumnContext = React.createContext();

const LinkListColumn = forwardRef(({ children }, ref) => {
  const { columnIncrementer } = useContext(LinkListContext);
  const [columnId] = useState(() => columnIncrementer());

  return (
    <LinkListColumnContext.Provider value={{ columnId }}>
      <div ref={ref} className={styles.column}>
        {children}
      </div>
    </LinkListColumnContext.Provider>
  );
});

LinkListColumn.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

LinkListColumn.displayName = "LinkList.Column";

export default LinkListColumn;
